import styled from "styled-components";

export const Container = styled.div`
	margin: 1.5rem 0;
	padding: 8px 1rem;
	min-height: 56px;
	border: 0.125rem solid var(--neutral-strong);
	border-radius: 0.5rem;

	display: flex;
`;

export const Content = styled.div`
	display: flex;
	align-items: center;
	gap: 1rem;

	font-size: 0.875rem;
	font-weight: 700;
	font-family: "Metropolis";
	color: var(--neutral-smoothest);
`;
